import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Heading from '@cotyorg/ccx-atoms/Heading';
import NavigationLink from '../NavigationLink';
import NavigationNestedLinks from './NavigationNestedLinks';

const NavigationLinks = ({
  pages: navLinks,
  selectedSlug,
  extraClass,
  linkExtraClass,
  linkTextExtraClass,
  titleExtraClass,
  disableNesting,
  forceSectionTitles,
  navLimit,
  headingLevel,
}) => {
  const navPages = navLimit && Array.isArray(navLinks) ? navLinks.slice(0, navLimit) : navLinks;

  return (
    <Fragment>
      {
        Array.isArray(navPages) && navPages.map((page) => {
          const {
            slug,
            name,
            pages,
            url,
            openInNewWindow,
            additionalClass,
            additionalId,
          } = page;

          const liClasses = classNames(
            'navigation__list-item--vertical',
            extraClass,
          );

          const linkClasses = classNames(
            'navigation__link',
            linkExtraClass,
          );

          const linkTextClasses = classNames(
            'navigation__link-text',
            linkTextExtraClass,
            additionalClass,
          );

          const titleClasses = classNames(
            titleExtraClass,
            additionalClass,
          );

          return (
            <li key={slug} className={liClasses} data-test="navigation-link">
              {
                (url && !forceSectionTitles) ?
                  <NavigationLink
                    extraClass={linkClasses}
                    textExtraClass={linkTextClasses}
                    name={name}
                    pages={pages}
                    url={url}
                    openInNewWindow={openInNewWindow}
                    selected={selectedSlug === slug}
                    rightChevronIconSrc="arrow-right.svg"
                    textExtraId={additionalId}
                  />
                  :
                  <Heading
                    level={headingLevel}
                    id={additionalId}
                    extraClass={titleClasses}
                  >
                    {name}
                  </Heading>
              }
              {
                !disableNesting && pages && !!pages.length &&
                <NavigationNestedLinks page={page} selectedSlug={selectedSlug} />
              }
            </li>
          );
        })
      }
    </Fragment>
  );
};

NavigationLinks.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    pages: PropTypes.array,
    openInNewWindow: PropTypes.bool,
  })).isRequired,
  selectedSlug: PropTypes.string,
  extraClass: PropTypes.string,
  linkExtraClass: PropTypes.string,
  linkTextExtraClass: PropTypes.string,
  titleExtraClass: PropTypes.string,
  disableNesting: PropTypes.bool,
  forceSectionTitles: PropTypes.bool,
  navLimit: PropTypes.number,
  headingLevel: PropTypes.number,
};

export default NavigationLinks;
